import { SearchBar } from 'antd-mobile';
import { useEffect, useRef } from 'react';
import s from '../index.module.scss';
const SearchContent = (props) => {
    const searchRef = useRef(null);
    useEffect(() => {}, [props.searchValue]);
    return (
        <div className={s['search-bar']}>
            <div style={{ flex: '1' }}>
                <SearchBar
                    placeholder="输入您所在的组织名称"
                    ref={searchRef}
                    onSearch={(val) => {
                        props.onSearch(val);
                    }}
                    onChange={(val) => {
                        props.setSearchValue(val);
                        if (!val || val === '') {
                            searchRef.current?.clear();
                            props.onClear();
                        }
                    }}
                    onClear={() => {
                        searchRef.current?.clear();
                        props.onClear();
                    }}
                    onFocus={() => {
                        setTimeout(() => {
                            let element = document.getElementById('myElement');
                            // 设置元素的样式
                            element.style.height = '350px';
                        }, 100);
                    }}
                    onBlur={() => {
                        let element = document.getElementById('myElement');
                        // 设置元素的样式
                        element.style.height = '598px';
                    }}
                    style={{
                        '--flex': '1',
                        '--background': 'rgba(234,238,249,0.4)',
                        '--border-radius': '8px',
                        '--height': '41px',
                        '--padding-left': '16px',
                        '--placeholder-color': '#B5BECE'
                    }}
                    value={props.searchValue}
                />
            </div>
            <span
                className={s['search-txt']}
                onClick={() => {
                    props.onSearch(props.searchValue);
                }}
            >
                搜索
            </span>
        </div>
    );
};
export default SearchContent;
